import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const IconLogo = () => {
  const data = useStaticQuery(
  graphql`
    {
      logo: file(relativePath: {eq: "logo.png"}) {
    		childImageSharp {
      			gatsbyImageData(layout: FIXED,width: 99)
    		}
  		}
    }
 `)
  
  return <GatsbyImage image={data.logo.childImageSharp.gatsbyImageData} alt="logo"/>

}

export default IconLogo


